import { makeStyles } from '@material-ui/core/styles';
  
const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    margin: '30px 300px',
    paddingBottom: '30px',
    [theme.breakpoints.down('md')]: {
      margin: '30px 20px'
    }
  },
  inputClassName: {
    marginBottom: theme.spacing(2),
    width: '100%'
  },
  chipsInput: {
    marginBottom: '20px',
    width: '100%'
  },
  datePickerWrapper: {
    marginBottom: theme.spacing(3),
    width: '100%'
  },
  currencyRow: {
    paddingBottom: '24px',
    marginBottom: '30px',
    borderBottom: '1px solid #e2ebf6'
  },
  dailyCurrencyRow: {
    display: 'block',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%'
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  currencyField: {
    width: '167px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      paddingLeft: '20px',
      paddingBlockStart: '20px',
      paddingRight: '20px'
    }
  },
  dailyCurrencyField: {
    width: '147px !important',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      paddingBottom: '20px !important'
    }
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '20px'
    }
  },
  buttonGroup:{
  marginBottom : "20px"
  },
  w: {
    width: '100%',
    padding: theme.spacing(2)
  },
  addEntry: {
    marginTop: '10px'
  },
  table: {
    marginBottom: '40px',
    overflowX: 'auto'
  },
  tableCell: {
    whiteSpace: 'nowrap'
  },
  iconButton: {
    padding: theme.spacing(1)
  },
  editIcon: {
    color: theme.palette.primary.main
  },
  closeIcon: {
    color: theme.palette.error.main
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  loaderWrapper: {
    position: 'fixed'
  }
}));
  
  export default useStyles;